import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-weave-password',
    templateUrl: './weave-password.component.html',
    styleUrls: ['./weave-password.component.scss'],
    standalone: false
})
export class WeavePasswordComponent implements OnInit {

  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() required: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUp: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;

  id: string = "passwordField";
  constructor() {}

  ngOnInit() {
    this.id = "weave-password" + Math.floor(Math.random() * 1000);
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }
  onKeyUp() {
    this.keyUp.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }

}
